import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import StaticBanner from "./StaticBanner.js";
import CarouselBanner from "./CarouselBanner.js";
import ProductCategory from "./ProductCategory.js";
import Heading from "./Header.js";
import Shortcuts from "./Shortcuts.js";
import { notNull } from "../sharedFunctions.js";
import { useLocation } from "react-router-dom";
import { fetchMenuFeedApi } from "../store/MenuFeedaction.js";
import { setActiveDiscounts } from "../store/slice/SiteSettingsSlice.js";
import { setLdScript, setMetaElements, structuredStoreJson, structuredWebsiteJson } from "../utility/seoUtils.js";

const Home = (props) => {
  const components = useSelector((state) => state?.content?.contentData?.components);
  const discounts = useSelector((state) => state?.discountData?.info?.coupons);

  const location = useLocation();
  const dispatch = useDispatch();
  const venue = useSelector((state) => state?.venue?.info?.venue);

  const queryParams = new URLSearchParams(location.search);
  const recache = queryParams.get('recache');

  useEffect(() => {
    dispatch(setActiveDiscounts(discounts));
  },[discounts])

  useEffect(() => {
    if (venue) {
      document.title = `${venue.name} | ${venue.address} ${venue.zip_code}`;
      const metaElements = [
        { property: "og:type", content: "website" },
        { property: "og:title", content: venue?.name },
        { property: "og:description", content: "Explore our products" },
        { property: "og:url", content: window.location.href },
        { property: "og:image", content: venue?.logo_medium },
        { property: "og:site_name", content: venue?.name },
        { property: "og:image:alt", content: venue?.name },
      ];

      setMetaElements(metaElements);
      setLdScript([structuredStoreJson(venue), structuredWebsiteJson(venue)]);
    }
  }, [venue]);


  if (recache) {
    dispatch(fetchMenuFeedApi({ recache: true }));
  }
  return (
    <>
      {
        notNull(components) && components.map((component,index) => {
          switch (component.type) {
            case "banner":
              return <StaticBanner key={index} component={component}/>
            case "heading":
              return <Heading key={index}/>;
            case "carousel":
              return <CarouselBanner key={index} component={component}/>
            case "category":
              return <ProductCategory key={index} component={component}/>;
            case "shortcut":
              return <Shortcuts key={index} component={component}/>;
            default:
              return null; // Handle other cases if necessary
          }
        })
      }
    </>
  )
}

export default Home
